export default function MoveButton({ children, onClick, disabled }) {
  return (
    <button
      className="flex justify-center items-center btn btn-goast h-7 w-7 disabled:text-altgray-500"
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
